import React from 'react';

import { IconSize, SvgIcon } from './SvgIcon';

interface IconProps {
  size?: IconSize;
}

const PaymentCardVisa = (props: IconProps): JSX.Element => (
  <SvgIcon size={props?.size}>
    <rect
      x=".75"
      y="3.75"
      width="22.5"
      height="16.5"
      rx="1.25"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <g clipPath="url(#clip0)">
      <path
        d="M10.4 15.1H8.9l1-6h1.5l-1 6zM16 9.3c-.4-.2-.9-.3-1.4-.3-1.5 0-2.6.8-2.6 2 0 .9.8 1.3 1.3 1.6.5.3.9.5.9.8 0 .3-.5.6-.9.6-.5 0-1-.1-1.4-.3l-.3-.2-.2 1.4c.5.2 1.1.3 1.7.3 1.6 0 2.7-.8 2.7-2 0-.7-.4-1.2-1.3-1.6-.5-.3-.9-.5-.9-.7 0-.2.3-.5.9-.5.4 0 .8.1 1.1.2l.1.1.3-1.4zM18.1 13c.1-.3.6-1.7.6-1.7s.1-.4.2-.6l.1.5s.3 1.4.4 1.7l-1.3.1zM20 9.1h-1.2c-.4 0-.7.2-.8.5l-2.3 5.5h1.6l.3-.9h2c0 .2.2.9.2.9h1.4l-1.2-6zM7.6 9.1l-1.5 4.1-.2-.8c-.4-1.1-1.1-2-2.1-2.5l1.4 5.2h1.6l2.4-6H7.6z"
        fill="#00579F"
      />
      <path
        d="M4.7 9.1H2.2v.1c1.7.4 3.1 1.5 3.7 3.1l-.5-2.7c-.1-.3-.4-.5-.7-.5z"
        fill="#FAA61A"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <path fill="#fff" transform="translate(2.2 9)" d="M0 0h19v6.2H0z" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default PaymentCardVisa;
